import { fetchChannelName, fetchHistoricalResults } from '@/api/homepage.api';

import { fetchLotteriesResults } from '@/api/v2/result.api.js';
import WinningNumbersSidebar from '@homepage/components/WinningNumbersSidebar.vue';

export default {
	components: {
		WinningNumbersSidebar
	},
	data() {
		return {
			channelName: null,
			results: [],
			autoRefreshInterval: null,
			externalLotteriesResults: [],
			sidebarOpen: false
		};
	},
	methods: {
		scrollToStream() {
			document.querySelector('#frame').scrollIntoView({
				behavior: 'smooth'
			});
		},
		fetchResults() {
			fetchHistoricalResults().then(response => {
				this.results = response.data.results;
			});
		}
	},
	created() {
		fetchChannelName().then(response => {
			this.channelName = response.data.channel;
		});
		fetchLotteriesResults().then(response => {
			this.externalLotteriesResults = response.data.results;
		});
		this.fetchResults();

		const every15MinutesRefresh = 900000;

		this.autoRefreshInterval = setInterval(() => {
			this.fetchResults();
		}, every15MinutesRefresh);
	},
	destroyed() {
		clearInterval(this.autoRefreshInterval);
	}
};
